module.exports = __webpack_public_path__ + "static/media/yu_hung_chang.65b8bad7.jpg";